import React from 'react';

import fetch from './../fetch';

import utils from './../../utils';

const prefixUrL = 'industryAnalysis/'

const columns = utils.columns([
	{
		key: '$index',
		label: '序号'
	},
	{
		key: 'studentNo',
		label: '学生学号',
	},
	{
		key: 'studentName',
		label: '学生姓名',
	},
	{
		key: 'enterpriseIndustry',
		label: '单位所属行业',
	},
	{
		key: 'enterpriseName',
		label: '就业具体单位',
	},
	{
        key: 'teacherCode',
        label: '导师工号'
    },
    {
        key: 'teacherName', 
        label: '导师姓名'
    },
	{
		key: 'termName',
		label: '学期名称',
	}
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
	let params = []
	if (keywords['sort'] != '$index') {
		for (var i in keywords) {
			if (i === 'order') {
				params.push(`order=${keywords[i]}`)
			}
			if (i === 'sort') {
				params.push(`sort=${keywords[i]}`)
			}
		}
	}
	params.push(`pageNum=${keywords.pageNum}`)
	params.push(`pageSize=${keywords.pageSize}`)
	return fetch.post(`${prefixUrL}queryByIndustry?` + params.join('&'), keywords)
		.then(response => {
			return response.payload.data;
		})
		.then(data => (Object.assign({
			result: data.dataList || [],
			selects: (data.dataList || []).map(d => ({
				value: d.id,
				checked: false
			})),
			checked: false,
			total: data.total,
			pageIndex: data.pageNum,
			pageSize: data.pageSize,
			notify: (data.dataList || []).length ? '' : '暂无数据...'
		})));
}

const DataGrid = {
	selections: [],
	refresh: function () {

	}
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
	DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
	return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
	DataGrid.refresh = callback;
};





export default {
	querySearch,
	columns,
	onSelect,
	setRefresh,
	getSelection,
}